<template>
  <section class="container section pt-5" v-show="show">
    <div class="button mb-3 is-primary is-rounded" @click="$emit('home')">
      <span class="icon">
        <i class="fa fa-arrow-left"></i>
      </span>
      <span>{{ $t("back") }}</span>
    </div>
    <div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("order number") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.order_number"
                placeholder="FMT-45"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field mt-3">
      <div class="control">
        <button class="button is-rounded is-primary" @click="search">
          <span class="icon">
            <i class="fa fa-search"></i>
          </span>
          <span>{{ $t("search") }}</span>
        </button>
      </div>
    </div>
    <div
      class="title is-4 pt-6"
      v-show="search_results && search_results.length"
    >
      {{ $t("search results") }}
    </div>
    <div
      class="title is-4 pt-6"
      v-show="!search_results || !search_results.length"
    >
      {{ $t("no results") }}
    </div>
    <div class="columns" v-for="(result, ridx) in search_results" :key="ridx">
      <div class="column is-2">{{ format_date(result.create_date) }}</div>
      <div class="column">
        <div class="title is-5">{{ result.name }}</div>
        <div class="tags has-addons">
          <span class="tag is-success"
            >{{ $t("total") }} {{ format_currency(result.total) }}</span
          >
          <span class="tag is-warning"
            >{{ $t("paid") }} {{ format_currency(result.total_paid) }}</span
          >
        </div>
        <div
          class="content"
          v-if="
            result.tailoring_order_payments &&
            result.tailoring_order_payments.length
          "
        >
          <div class="title is-6">{{ $t("payments") }}</div>
          <ul>
            <li
              v-for="(item, idx) in result.tailoring_order_payments"
              :key="idx"
            >
              <span>{{ item.date }}</span> -
              <span>{{ format_currency(item.amount) }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="column">
        <div
          class="tags has-addons"
          v-for="(item, iidx) in result.tailoring_order_items"
          :key="iidx"
        >
          <span class="tag is-primary"
            >{{ item.quantity }} x {{ item.product_name }}
          </span>
          <span class="tag">{{
            format_currency(Number(item.price) * Number(item.quantity))
          }}</span>
          <span class="tag is-info">{{ item.size.toUpperCase() }}</span>
          <span class="tag">{{ item.customization }}</span>
        </div>
        <!-- <pre>{{ result.tailoring_order_items }}</pre> -->
      </div>
      <div class="column" v-if="false">
        <button
          class="button is-rounded is-primary"
          @click="register_payment(result)"
        >
          <span class="icon"><i class="fa fa-credit-card"></i></span>
          <span>{{ $t("register payment") }}</span>
        </button>
      </div>
    </div>
    <!-- <pre>{{ search_results }}</pre> -->
  </section>
</template>

<script>
import {
  get,
  post,
  error_message,
  format_currency,
  format_date,
} from "@/utils";

export default {
  name: "TailoringOrderFind",
  components: {},
  computed: {},
  data() {
    return {
      meta: {
        phone: "",
        order_number: "",
      },
      search_results: [],
      show: true,
    };
  },
  methods: {
    format_currency,
    format_date,
    search() {
      let v = this;
      get("/tailoring_order/link/search", {
        order_number: v.meta.order_number,
      })
        .then((response) => {
          v.search_results = response;
        })
        .catch((error) => {
          error_message(error);
          console.error(error);
        });
    },
    add_product(product, size) {
      let v = this;
      v.meta.selected_products.push({
        quantity: 1,
        product: product,
        size: size,
      });
    },
    show_component() {
      let v = this;
      v.show = true;
    },
    hide() {
      let v = this;
      v.show = false;
    },
    register_payment(item) {
      let v = this;
      console.log("register payment", item.uuid);
      window.open(`/tailoring_order/payment/${item.uuid}`, "_blank");
      // v.$router.push({ path: `/tailoring_order/payment/${item.uuid}` });
      // v.$router.push({
      //   path: "/tailoring_order/payment",
      //   query: { uuid: item.uuid },
      // });
    },
  },
  mounted() {
    let v = this;
    let url_name = v.$route.params.id;
    get("/tailoring_order/link", { url_name })
      .then((response) => {
        v.order_link = response;
      })
      .catch((error) => {
        console.error(error);
      });
  },
  created() {},
};
</script>

<style scoped></style>
